var map = {
	"./EN.md": [
		75840,
		840
	],
	"./JA.md": [
		34281,
		281
	],
	"./KO.md": [
		94286,
		286
	],
	"./MS.md": [
		21228,
		228
	],
	"./RU.md": [
		69973,
		973
	],
	"./TH.md": [
		24046,
		46
	],
	"./VI.md": [
		77707,
		707
	],
	"./ZH.md": [
		24358,
		358
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 76568;
module.exports = webpackAsyncContext;